// Updated PageTitle component
import React from 'react'
import { NavLink } from 'react-router-dom';

const PageTitle = ({ title, subtitle, children, className, breadcrumbs }) => {
    return (
        <>
            <div className={`user-page-head ${className}`}>
                <div className="left">
                    {breadcrumbs &&
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                {breadcrumbs && (
                                    breadcrumbs.map((crumb, index) => (
                                        <li key={index} className={`breadcrumb-item ${index === breadcrumbs.length - 1 ? 'active' : ''}`}
                                            aria-current={index === breadcrumbs.length - 1 ? 'page' : undefined}>
                                            {crumb.to ? (
                                                <NavLink to={crumb.to}>{crumb.label}</NavLink>
                                            ) : (
                                                crumb.label
                                            )}
                                        </li>
                                    ))
                                )}
                            </ol>
                        </nav>
                    }

                    <div className="page-info">
                        <div className="page-title">
                            {title}
                        </div>
                        {subtitle && (
                            <div className="text-muted">
                                {subtitle}
                            </div>
                        )}
                    </div>
                </div>
                <div className="right">
                    <div className="button-row end">
                        {children && children}
                    </div>
                </div>
            </div>
        </>
    )
}

export default React.memo(PageTitle);